import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import WhiteListAddressFormComponent from './WhiteListAddressFormComponent';
import { closeSidePane } from 'apex-web/lib/redux/actions/sidePaneActions';
import {
  fetchAccountWithdrawInfos,
  CreateAccountWithdrawInfo
} from 'apex-web/lib/redux/actions/eotcWithdrawActions';

const mapStateToProps = (state, { ProductId, ProductFullName }) => {
  return {
    ProductId,
    ProductFullName
  };
};

const mapDispatchToProps = dispatch => ({
  close: () => dispatch(closeSidePane()),
  fetchAccountWithdrawInfos: () => dispatch(fetchAccountWithdrawInfos())
});

const WhiteListAddressForm = reduxForm({
  form: 'WhiteListAddress',
  onSubmit: (payload, dispatch, { ProductId }) => {
    dispatch(
      CreateAccountWithdrawInfo({
        ...payload,
        ProductId
      })
    );
  }
})(WhiteListAddressFormComponent);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WhiteListAddressForm);
